import { Link } from "react-router-dom";
import { Check, User, Phone, Mail } from "lucide-react";
import { Logo } from "@/components/Logo";
import { carLabel, plDate, zl, SERVICE_LABELS } from "@/lib/api";

const Row = ({ label, value, testid }) => (
  <div><div className="text-xs text-muted-foreground">{label}</div><div data-testid={testid} className="text-sm mt-0.5">{value}</div></div>
);

export const BookingSuccess = ({ booking: d }) => (
  <section data-testid="booking-success" className="grid lg:grid-cols-[auto_1fr_1.2fr] gap-10 items-center py-10">
    <div className="hidden lg:block"><Logo className="h-36" /></div>
    <div className="text-center rise">
      <div className="w-20 h-20 rounded-full border-2 border-primary grid place-items-center mx-auto mb-6 glow-y"><Check size={38} className="text-primary" /></div>
      <h1 className="font-display text-4xl font-bold">Gotowe!</h1>
      <p className="mt-3">Termin został zarezerwowany.</p>
      <p className="text-sm text-muted-foreground mt-2">Potwierdzenie wysłaliśmy na Twój e-mail.</p>
      <Link to="/" data-testid="back-home-button" className="btn-y inline-block px-10 py-3 mt-8 text-sm">Powrót do strony głównej</Link>
    </div>
    <div className="panel p-6 grid sm:grid-cols-2 gap-6 rise d2">
      <div className="space-y-5">
        <div className="flex gap-3"><User size={18} className="text-primary mt-1" /><Row label="Imię i nazwisko" value={d.name} testid="success-name" /></div>
        <div className="flex gap-3"><Phone size={18} className="text-primary mt-1" /><Row label="Telefon" value={d.phone} /></div>
        <div className="flex gap-3"><Mail size={18} className="text-primary mt-1" /><Row label="E-mail" value={d.email} /></div>
      </div>
      <div className="space-y-4">
        <Row label="Usługa" value={[d.package_name, ...d.addons.map((a) => a.name)].join(" + ")} />
        <Row label="Samochód" value={carLabel(d.car_type)} />
        <Row label="Termin" value={`${plDate(d.date)} · ${d.time}`} testid="success-term" />
        <Row label="Rodzaj usługi" value={`${SERVICE_LABELS[d.service_type]}${d.pickup ? " + odbiór auta" : ""}`} />
        {d.address && <Row label="Adres" value={d.address} testid="success-address" />}
        <Row label="Razem" value={zl(d.total)} testid="success-total" />
      </div>
    </div>
  </section>
);
